import {
  // Start of Mapping imports
  ParagraphAccordeon,
  ParagraphAccordeonItem,
  ParagraphAnnualReportThemesOverview,
  ParagraphChapterMap,
  ParagraphContactInformation,
  ParagraphContentOverview,
  ParagraphContentSlider,
  ParagraphCta,
  ParagraphCtaBlock,
  ParagraphCtaCampaign,
  ParagraphCtaIconBlock,
  ParagraphDonate,
  ParagraphDonationForm,
  ParagraphDownloadList,
  ParagraphHeroCarouselItem,
  ParagraphHeroCarouselItemDonation,
  ParagraphImage,
  ParagraphImageSlider,
  ParagraphIndexSummary,
  ParagraphInformationalCta,
  ParagraphLocationsMap,
  ParagraphPartners,
  ParagraphQuote,
  ParagraphRecentContent,
  ParagraphSelectedContent,
  ParagraphText,
  ParagraphTextWithIcon,
  ParagraphTextWithIconContainer,
  ParagraphTextWithImage,
  ParagraphThemes,
  ParagraphTopics,
  ParagraphVacancyDetails,
  ParagraphVideo,
  ParagraphWebform,
} from '../implementations';

const mappers = {
  // Start of Mapping entries
  accordeon_item: ParagraphAccordeonItem,
  accordeon: ParagraphAccordeon,
  annual_report_themes_overview: ParagraphAnnualReportThemesOverview,
  chaptermap: ParagraphChapterMap,
  contact_information: ParagraphContactInformation,
  content_overview: ParagraphContentOverview,
  content_slider: ParagraphContentSlider,
  cta_block: ParagraphCtaBlock,
  cta_campaign: ParagraphCtaCampaign,
  cta_icon_block: ParagraphCtaIconBlock,
  cta: ParagraphCta,
  donate: ParagraphDonate,
  donation_form: ParagraphDonationForm,
  download_list: ParagraphDownloadList,
  hero_carousel_item_donation: ParagraphHeroCarouselItemDonation,
  hero_carousel_item: ParagraphHeroCarouselItem,
  image_slider: ParagraphImageSlider,
  image: ParagraphImage,
  index_summary: ParagraphIndexSummary,
  informational_cta: ParagraphInformationalCta,
  locations_map: ParagraphLocationsMap,
  partners: ParagraphPartners,
  quote: ParagraphQuote,
  recent_content: ParagraphRecentContent,
  selected_content: ParagraphSelectedContent,
  text_with_icon_container: ParagraphTextWithIconContainer,
  text_with_icon: ParagraphTextWithIcon,
  text_with_image: ParagraphTextWithImage,
  text: ParagraphText,
  themes: ParagraphThemes,
  topics: ParagraphTopics,
  vacancy_details: ParagraphVacancyDetails,
  video: ParagraphVideo,
  webform: ParagraphWebform,
};

export default mappers;
